import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import numeral from 'numeral';
import { fetchData, clearErrorMessage } from '../../actions';
import ReactLoading from 'react-loading';
import {Table, Column, Cell} from 'fixed-data-table-2';
import 'fixed-data-table-2/dist/fixed-data-table.css'
//import { resizeTableModal, toggleTableModal } from '../../actions/table.js';
//import Modal from '../Modal/Modal';
//import SummaryTableView from './SummaryTableView';
import fileDownload from 'js-file-download';
import { Parser as Json2csvParser } from 'json2csv';
import '../../css/table.css'
import table_styles from '../../css/table.css';

var SortTypes = {
  ASC: 'ASC',
  DESC: 'DESC'
};

function reverseSortDirection(sortDir) {
  return sortDir === SortTypes.DESC ? SortTypes.ASC : SortTypes.DESC;
}

class SortHeaderCell extends React.Component {
  constructor(props) {
    super(props);
    this._onSortChange = this._onSortChange.bind(this);
  }

  render() {
    var {onSortChange, sortDir, children, ...props} = this.props;
    return (
      <Cell {...props}>
        <div style={{cursor: 'pointer', textAlign: 'center'}} onClick={this._onSortChange}>
          {children} {sortDir ? (sortDir === SortTypes.DESC ? '↓' : '↑') : ''}
        </div>
      </Cell>
    );
  }

  _onSortChange(e) {
    e.preventDefault();
    if (this.props.onSortChange) {
      this.props.onSortChange(
        this.props.columnKey,
        this.props.sortDir ?
          reverseSortDirection(this.props.sortDir) :
          SortTypes.DESC
      );
    }
  }
}

class DataListWrapper {
  constructor(indexMap, data) {
    this._indexMap = indexMap;
    this._data = data;
  }
  getSize() {
    return this._indexMap.length;
  }
  getObjectAt(index) {
    return this._data.getIn([this._indexMap[index]])
  }
}

const TextCell = ({data, col, formatFx, rowIndex, ...props}) => (
  <Cell {...props}>
    {formatFx ? formatFx(data._data.getIn([data._indexMap[rowIndex],col])) : data._data.getIn([data._indexMap[rowIndex],col])}
  </Cell>
)

class DataTableViewComp extends Component {

  constructor(props){
    super(props)
    this._data = props.data;
    //this._data = props.data.filter(x => x.get('m_risk_rank'));   // filter to Marietta's risk properties

    this._defaultSortIndexes = [];
    var size = this._data.size;
    for (var index = 0; index < size; index++) {
      this._defaultSortIndexes.push(index);
    }

    this.updateTableWidth = this.updateTableWidth.bind(this);

    this._dataList = new DataListWrapper(this._defaultSortIndexes, this._data)

    this.state = {
      parameter: props.parameter,
      filteredData: this._data,
      sortedDataList: this._dataList,
      colSortDirs: {},
      columnWidths: {
        'cty_tmk': 70,
        'parcel_type': 70,
        'owner': 100,
        'description': 200,
        'acres': 50,
        'acres_portions': 50,
        'acres_owned': 50,
        'acres_owned_adjacent': 50,
        'gisacres': 50,
        'include': 50,
        'value': 70,
        //'m_risk_rank': 50,
        'hcs_fields': 100
      },
      tableWidth: 1000,
      modalIsOpen: false,
      modalMessage: ''
    }

    this._onSortChange = this._onSortChange.bind(this);
    this._onColumnResizeEndCallback = this._onColumnResizeEndCallback.bind(this);

    this.openModal = this.openModal.bind(this);
    this.afterOpenModal = this.afterOpenModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  componentWillMount(){
    this.setState({"navBarHeight": 42})
    this.setState({"height": window.innerHeight - (42 + 100) })
    if(this.props.rawData.size === 0) {
      this.props.dispatch(fetchData());
    }
  }

  componentWillReceiveProps(nextProps) {
    var columnKey = Object.keys(this.state.colSortDirs);

    this._data = nextProps.data;
    //this._data = nextProps.data.filter(x => x.get('m_risk_rank'));   // filter to Marietta's risk properties

    this._defaultSortIndexes = [];
    var size = this._data.size;
    for (var index = 0; index < size; index++) {
      this._defaultSortIndexes.push(index);
    }

    if(columnKey.length > 0) {
      var sortIndexes = this._defaultSortIndexes.slice();
      sortIndexes.sort((indexA, indexB) => {
        var valueA = this._dataList._data.getIn([indexA, columnKey]);
        var valueB = this._dataList._data.getIn([indexB, columnKey]);
        // numeric sorting
        if(columnKey[0] === 'acres' || columnKey[0] === 'acres_owned' || columnKey[0] === 'gisacres') {
          valueA = +valueA;
          valueB = +valueB;
        }
        // date sorting
        if(columnKey[0] === 'sample_date') {
          valueA = moment(valueA, 'll').toDate();
          valueB = moment(valueB, 'll').toDate();
        }
        var sortVal = 0;
        if (valueA > valueB) {
          sortVal = 1;
        }
        if (valueA < valueB) {
          sortVal = -1;
        }
        if (sortVal !== 0 && this.state.colSortDirs[columnKey[0]] === SortTypes.ASC) {
          sortVal = sortVal * -1;
        }
        return sortVal;
      });

      this._dataList = new DataListWrapper(sortIndexes, this._data)
    } else {
      this._dataList = new DataListWrapper(this._defaultSortIndexes, this._data)
    }

    this.setState({
      filteredData: this._data,
      sortedDataList: this._dataList
    });

    if(nextProps.errorMessage) {
      this.setState({modalMessage: nextProps.errorMessage });
      this.setState({modalIsOpen: true});
    }
  }

  /**
  * Add event listener to resized fixed width table
  */
  componentDidMount() {
    this.updateTableWidth();
    window.addEventListener("resize", this.updateTableWidth);
  }

  /**
  * Remove event listener to resized fixed width table
  */
  componentWillUnmount() {
    window.removeEventListener("resize", this.updateTableWidth);
  }


  _onColumnResizeEndCallback(newColumnWidth, columnKey) {
    this.setState(({columnWidths}) => ({
      columnWidths: {
        ...columnWidths,
        [columnKey]: newColumnWidth,
      }
    }));
  }

  _onSortChange(columnKey, sortDir) {
    var sortIndexes = this._defaultSortIndexes.slice();
    sortIndexes.sort((indexA, indexB) => {
      var valueA = this._dataList._data.getIn([indexA, columnKey]);
      var valueB = this._dataList._data.getIn([indexB, columnKey]);
      // numeric sorting
      if(columnKey === 'acres' || columnKey === 'acres_owned' || columnKey[0] === 'gisacres') {
        valueA = +valueA;
        valueB = +valueB;
      }
      // date sorting
      if(columnKey === 'sample_date') {
        valueA = moment(valueA, 'll').toDate();
        valueB = moment(valueB, 'll').toDate();
      }
      var sortVal = 0;
      if (valueA > valueB) {
        sortVal = 1;
      }
      if (valueA < valueB) {
        sortVal = -1;
      }
      if (sortVal !== 0 && sortDir === SortTypes.ASC) {
        sortVal = sortVal * -1;
      }
      return sortVal;
    });

    this.setState({
      sortedDataList: new DataListWrapper(sortIndexes, this._data),
      colSortDirs: {
        [columnKey]: sortDir,
      },
    });
  }

  updateTableWidth() {
    this.setState({ tableWidth: document.getElementById("dataTable").clientWidth });
  }

  openModal() {
    this.setState({modalIsOpen: true});
  }

  afterOpenModal() {
    this.subtitle.style.color = '#222';
  }

  closeModal() {
    this.setState({modalIsOpen: false});
    this.props.dispatch(clearErrorMessage())
  }

  resizeTableModal(table,width,height){
    //this.props.dispatch(resizeTableModal(table,width,height))
  }

  downloadData(){
    //var fields = Object.keys(results.data[0])
    var fields = [{
      value: 'cty_tmk', label: 'Cty TMK'
    },{
      value: 'parcel_type', label: 'Type'
    },{
      value: 'owner', label: 'Owner'
    },{
      value: 'description', label: 'Description'
    },{
      value: 'acres', label: 'Acres (total)'
    },{
      value: 'gisacres', label: 'GIS Acres'
    },{
      value: 'include', label: 'Status'
    },{
      value: 'hcs_fields', label: 'HC&S Fields'
    }];
    const opts = { fields }
    try {
      const parser = new Json2csvParser(opts)
      const csv = parser.parse(this.props.data.toJS())
      //console.log(csv)
      fileDownload(csv, 'parcel_data.csv')
    } catch (err) {
      console.error(err);
    }
  }
  /*toggleTableModal(table){
    if(!this.props.showSummaryTable) {
      this.props.dispatch(setBusyText("Calculating..."));
      this.props.dispatch(calculatingData());
      this.props.dispatch(toggleTableModal(table));
      this.props.dispatch(doneCalculatingData());
    } else {
      this.props.dispatch(toggleTableModal(table));
    }
  }*/

  render() {

    const isBusy = this.props.isBusy;

    var data = this.state.sortedDataList;

    var colSortDirs = this.state.colSortDirs;

    var columnWidths = this.state.columnWidths;

    var headerHeight = 37;

    var acresFormat = function(x) {
      return numeral(x).format('0,0.[00]')
    }

    /*var valueFormat = function(x) {
      return numeral(x).format('0,0')
    }*/

    //var includedColumnsInOrder = ['tmk','parcel_type','owner','description','acres','acres_portions','acres_owned','acres_owned_adjacent','include','value','risk_rank','hcs_fields']
    var includedColumnsInOrder = ['cty_tmk','parcel_type','owner','description','acres','gisacres','include','hcs_fields']; //'m_risk_rank',

    var allColumnsInfo = {
      cty_tmk: { title: 'TMK', flexGrow: 1, width: columnWidths.cty_tmk, fixed: true, align: 'center', isResizable: true, formatFx: null },
      parcel_type: { title: 'Type', flexGrow: 1, width: columnWidths.parcel_type, fixed: false, align: 'center', isResizable: true, formatFx: null },
      owner: { title: 'Owner', flexGrow: 1, width: columnWidths.owner, fixed: false, align: 'center', isResizable: true, formatFx: null },
      description: { title: 'Description', flexGrow: 1, width: columnWidths.description, fixed: false, align: 'center', isResizable: true, formatFx: null },
      acres: { title: 'Acres (total)', flexGrow: 1, width: columnWidths.acres, fixed: false, align: 'center', isResizable: true, formatFx: acresFormat },
      gisacres: { title: 'GIS Acres', flexGrow: 1, width: columnWidths.gisacres, fixed: false, align: 'center', isResizable: true, formatFx: acresFormat },
      //acres_portions: { title: 'Acres (portion)', flexGrow: 1, width: columnWidths.acres_portions, fixed: false, align: 'center', isResizable: true, formatFx: acresFormat },
      //acres_owned: { title: 'Acres (owned)', flexGrow: 1, width: columnWidths.acres_owned, fixed: false, align: 'center', isResizable: true, formatFx: acresFormat },
      //acres_owned_adjacent: { title: 'Acres (adj.)', flexGrow: 1, width: columnWidths.acres_owned_adjacent, fixed: false, align: 'center', isResizable: true, formatFx: acresFormat },
      include: { title: 'Status', flexGrow: 1, width: columnWidths.include, fixed: false, align: 'center', isResizable: true, formatFx: null },
      //value: { title: 'Value ($)', flexGrow: 1, width: columnWidths.value, fixed: false, align: 'center', isResizable: true, formatFx: valueFormat },
      //m_risk_rank: { title: 'Initial Risk Rank', flexGrow: 1, width: columnWidths.m_risk_rank, fixed: false, align: 'center', isResizable: true, formatFx: null },
      hcs_fields: { title: 'Fields', flexGrow: 1, width: columnWidths.hcs_fields, fixed: false, align: 'center', isResizable: true, formatFx: null }
    }

    var tableWidth = this.state.tableWidth || 1000;

    var me = this;
    let dataSize = data.getSize()
    return (
      <div className='row' id="dataTable">
        {isBusy ? (
          <div style={{marginTop: (this.props.height * 0.25) || 100, marginLeft: '-12.5%', zIndex:1000000, width:'25%', height:'25%', backgroundColor:'rgba(255,255,255,0.0)', position:'absolute', top:'20%',left:'50%'}}>
            <ReactLoading type='bubbles' color='#333333' height='25%' width='40%' className='center-loader' />
          </div>) : (
          null
        )}
        <div className='col-md-12' style={{height: table_styles.topSpace + 'px'}}>
          <div id="dataFilterTitle" className='col-sm-3 pull-left'>
            <h3>Data: {dataSize} rows</h3>
          </div>
          <div className='col-sm-9 float-right' id='downloadButton' style={{paddingTop: '7px'}}>
            <button className='btn btn-info float-right' type="button" onClick={this.downloadData.bind(this)}>Download</button>
          </div>
          {/*<div className='col-sm-6 pull-right' id='summaryButton' style={{paddingTop: '3px'}}>
            <button className={this.props.store.get('showSummaryTable') ? "btn btn-info plot-toggle toggled-on" : 'btn btn-info plot-toggle'} type="button" onClick={this.toggleTableModal.bind(this, 'summary')}>Summary Table</button>
          </div>*/}
        </div>
        <Table
          rowHeight={35}
          headerHeight={headerHeight}
          rowsCount={dataSize}
          onColumnResizeEndCallback={this._onColumnResizeEndCallback}
          isColumnResizing={false}
          width={tableWidth}
          maxHeight={this.props.template.compHeight - table_styles.topSpace}
          style={{padding:'0 10px'}}
          {...this.props}
        >
        {includedColumnsInOrder.map(function (columnKey, i) {
          return <Column
            columnKey={columnKey}
            key={i}
            header={<SortHeaderCell
               onSortChange={me._onSortChange}
               sortDir={colSortDirs[columnKey]}>
                  {allColumnsInfo[columnKey].title}
               </SortHeaderCell>}
            cell={<TextCell data={data} col={columnKey} formatFx={allColumnsInfo[columnKey].formatFx}/>}
            align={allColumnsInfo[columnKey].align}
            flexGrow={allColumnsInfo[columnKey].flexGrow}
            width={allColumnsInfo[columnKey].width}
            fixed={allColumnsInfo[columnKey].fixed}
            isResizable={allColumnsInfo[columnKey].isResizable}
          />;
        })}
        </Table>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    store: state.TableApp,
    isBusy: state.isBusy,
    //selectedQuery: state.QueryApp.get('selectedQuery'),
    //parameters: state.FilterApp.get('parameters'),
    parameter: state.FilterApp.get('parameter'),
    data: state.DataApp.get('filteredData'),
    //data: state.DataApp.get('filteredProperties'),
    rawData: state.DataApp.get('modifiedData'),
    //showSummaryTable: state.TableApp.get('showSummaryTable'),
    errorMessage: state.TableApp.get('errorMessage'),
    template:state.Template
  }
}

const DataTableView = connect(mapStateToProps)(DataTableViewComp)

export default DataTableView;



// WEBPACK FOOTER //
// ./src/components/TableView/DataTableView.js